import React, { useMemo } from 'react';
import { Person, PersonPermission, usePeopleService } from 'nekst-api';
import { useAuthorizationChecker } from 'authorization-scope';
import { AfterSubmitFunc, SubmitButton } from 'ui-builder';
import { BasePersonFormTemplate } from './Shared/BasePersonFormTemplate';
import { UpdatePersonFormFields } from './UpdatePersonFormFields';
function convertPlainTextSignatureToHtml(emailSignature?: string): string {
  const value = emailSignature || '';
  if (value.length === 0 || value[0] === '<') {
    return value;
  }

  const separator = value.includes("\r\n") ? "\r\n" : "\n";
  const parts = value.split(separator);

  if (parts.length > 1) {
    return parts.map((part) => '<p>' + part + '</p>').join(' ');
  } else {
    return value;
  }
}

export function UpdatePersonForm(
  props: {
    person: Person,
    afterSubmitFunc?: AfterSubmitFunc<Person>,
  },
) {
  const peopleService = usePeopleService();

  const { isGranted } = useAuthorizationChecker();

  const initialData = useMemo(() => ({
    ...props.person,
    profile: {
      ...props.person.profile,
      emailSignature: props.person.profile.usePlainHtmlSignature
        ? props.person.profile.emailSignature
        : convertPlainTextSignatureToHtml(props.person.profile.emailSignature),
    },
  }), [props.person]);

  return (
    <BasePersonFormTemplate<Person>
      submitFormFunc={async (data) => peopleService.update(props.person.id, data)}
      afterSubmitFunc={props.afterSubmitFunc}
      initialData={initialData}
      buttons={<SubmitButton text="Save" />}
      validationSchema={(data) => peopleService.getUpdateValidationSchema(data.teamRole)}
      isDisabled={!isGranted(PersonPermission.UPDATE)}
      title={props.person.profile.name.fullName}
    >
      <UpdatePersonFormFields person={props.person} />
    </BasePersonFormTemplate>
  );
}
